import apiRequest from "utils/apiRequestWithErrorCode";
import type {
  SourceConfiguration,
  Source,
  UpdateSourceRequest,
} from "@dashboard-v3/api";

// Sources ---
export async function fetchSources() {
  return apiRequest<Source[]>("GET", "/sources");
}

export async function fetchSource(id: string) {
  return apiRequest<Source>("GET", `/sources/${id}`);
}

export async function deleteSource(id: string) {
  await apiRequest("DELETE", `/sources/${id}`);
}

export async function refreshSync(id: string) {
  return apiRequest("PATCH", `/sources/${id}`, { refresh: true });
}

export async function createSource(sourceConfig: SourceConfiguration) {
  return await apiRequest<Source>("POST", "/sources", sourceConfig);
}

export async function updateSource(id: string, update: UpdateSourceRequest) {
  return await apiRequest<Source>("PATCH", `/sources/${id}`, update);
}
